import React from "react";
import one from "./Apple Logo@2x.png";
import two from "./Google Play@2x.png";
import "./Download.css";
import { FaAppStoreIos, FaPlay } from "react-icons/fa";
import { FaPhoneAlt } from "react-icons/fa";

const Download = () => {
  return (
    <div className="text-center pb-5 mb-5 pt-5">
      <h1 className="fw-bolder pt-5">
        Ready To <span className="text-color">Download</span>
      </h1>
      <p className="p-3">Download from App Store or Google Play.</p>
      {/* <div className="my-3" style={{ fontSize: "30px" }}>
        <FaPhoneAlt className="me-2" />{" "}
        <span className="fw-bolder">
          01896192221, 01896192225 & 01896192229
        </span>
      </div> */}
      {/* <div className="">
        <div className="row row-cols-lg-2  row-cols-1">
          <div className="col text-lg-end py-2"> */}
      <button className="downloadBtn rounded-pill">
        <div className="d-flex text-center align-items-center">
          <div className="down px-2">
            <img className="tmg-fluid" src={one} alt="" />
          </div>
          <div>
            <p className="mt-3">
              <span className="ps-3">|</span> Download App
            </p>
          </div>
        </div>
      </button>
      {/* </div> */}
      {/* <div className="col text-lg-start  py-2">
        <button className="btn btn-light rounded-pill">
          <div className="d-flex   text-center align-items-center ">
            <div className="down px-2">
              <img className="img-fluid" src={two} alt="" />
            </div>
            <div>
              <p className="mt-3 ">| Download App on app store</p>
            </div>
          </div>
        </button>
        <button className="downloadBtn rounded-pill">
          <div className="d-flex  text-center align-items-center ">
            <div className="down px-2">
              <FaPlay style={{ fontSize: "23px" }} />
            </div>
            <div>
              <p className="mt-3 ">
                {" "}
                <span className="ps-3">|</span> Viw Promotion
              </p>
            </div>
          </div>
        </button>
      </div> */}
      {/* </div>
      </div> */}
    </div>
  );
};

export default Download;
